import { Tab, Tabs, Stack, alpha, Typography } from '@mui/material';
import { useState, useCallback } from 'react';
import Iconify from 'src/components/iconify';
import { useSearchParams } from 'react-router-dom';
import SettingSystem from '../tabs/system/setting-system';
import SettingFee from '../tabs/fee/setting-fee';
import SettingBankAccount from '../tabs/bank-account/setting-bank-account';
import SettingBranch from '../tabs/branch/setting-branch';
import SettingDayOff from '../tabs/day-off/setting-day-off';
import SettingSourcePrice from '../tabs/source-price/setting-source-price';
import SettingProfit from '../tabs/profit/setting-profit';

const tabs = [
  {
    value: 'system',
    label: 'ระบบ',
    icon: <Iconify icon="solar:settings-bold-duotone" width={24} />,
  },
  {
    value: 'fee',
    label: 'ค่าธรรมเนียม',
    icon: <Iconify icon="solar:bill-list-bold-duotone" width={24} />,
  },
  {
    value: 'source-price',
    label: 'แหล่งอ้างอิงราคา',
    icon: <Iconify icon="solar:settings-bold-duotone" width={24} />,
  },
  {
    value: 'profit',
    label: 'ส่วนต่างราคา',
    icon: <Iconify icon="solar:settings-bold-duotone" width={24} />,
  },
  {
    value: 'bank',
    label: 'บัญชีธนาคาร',
    icon: <Iconify icon="solar:banknote-bold-duotone" width={24} />,
  },
  {
    value: 'branch',
    label: 'สาขา',
    icon: <Iconify icon="solar:buildings-bold-duotone" width={24} />,
  },
  {
    value: 'day-off',
    label: 'วันหยุดทำการ',
    icon: <Iconify icon="solar:calendar-bold-duotone" width={24} />,
  },
];

export default function SettingView() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<string>(() => {
    const paramTab = searchParams.get('tab');
    if (!paramTab) {
      return tabs[0].value;
    }
    const tab = tabs.find((t) => t.value === paramTab);
    return tab ? paramTab : tabs[0].value;
  });

  const handleChangeTab = useCallback((event: React.SyntheticEvent, tab: string) => {
    setSearchParams({ tab }, { replace: true });
    setActiveTab(tab);
  }, []);

  return (
    // <Container>
    <Stack spacing={2}>
      <Typography variant="h4" gutterBottom>
        ตั้งค่า
      </Typography>

      <Tabs
        value={activeTab}
        onChange={handleChangeTab}
        sx={{
          boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`,
        }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.value} label={tab.label} icon={tab.icon} value={tab.value} />
        ))}
      </Tabs>

      {activeTab === 'system' && <SettingSystem />}

      {activeTab === 'fee' && <SettingFee />}

      {activeTab === 'source-price' && <SettingSourcePrice />}

      {activeTab === 'profit' && <SettingProfit />}

      {activeTab === 'bank' && <SettingBankAccount />}

      {activeTab === 'branch' && <SettingBranch />}

      {activeTab === 'day-off' && <SettingDayOff />}
    </Stack>
    // </Container>
  );
}
